"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.voice-agent.disabled': 'Voice agent feature is not available in your current plan.',
};
